var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRanking1 = function SvgRanking1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.655 6.472H2.517V.33a.33.33 0 0 1 .33-.33h10.482a.33.33 0 0 1 .33.33v6.142h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA541C",
    d: "M2.517 0h2.666v5.86H2.517V0zm4.25 0h2.637v5.86H6.768V0zm4.222 0h2.666v5.86H10.99V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA39E",
    d: "M.009 11.692a8.075 8.075 0 0 0 12.179 7.187 8.077 8.077 0 0 0 3.968-7.187 8.078 8.078 0 1 0-16.148 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D4F",
    d: "M2.078 11.692a6.008 6.008 0 1 0 12.016 0 6.008 6.008 0 0 0-12.016 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.658 15.818v-6.37l-1.803 1.565V8.937l1.803-1.565h1.944v8.446z"
  }))));
};
export default SvgRanking1;